import WithoutInformation from "./WithoutInformation";
import { useQuery } from "react-query";
import {
  listTotalClients,
  listClientSex,
  listClientStatus,
  listClientThermometer,
  listClientAge,
  listClientProfession,
  listCustomerTotalizers,
} from "../../services/insights";
import { useStyles } from "./styles";
import Stack from "@mui/material/Stack";
import { Email, Group, LocationOn, PhoneIphone } from "@mui/icons-material";
import { Bar } from "../../components/Recharts/Bar";
import { isEmpty } from "lodash";
import { Paper } from "../../components/Paper";
import { PaperChart } from "../../components/PaperChart";
import { useAudience } from "../../hooks/useAudience";

function AnalyticsView() {
  const styles = useStyles();
  const { filtroConsulta } = useAudience();

  const {
    isLoading: isLoadingClients,
    data: { totalClientes, clientes } = {
      totalClientes: [],
      clientes: { clientes: [], n_compraram: {}, total: 0 },
    },
  } = useQuery(
    ["analytics component", "listTotalClients", filtroConsulta.changeToRefetch],
    async () => {
      const response = await listTotalClients(filtroConsulta);

      return { totalClientes: response.total, clientes: response.response };
    }
  );

  const { isLoading: isLoadingGenre, data: sexo = [] } = useQuery(
    ["analytics component", "listClientSex", filtroConsulta.changeToRefetch],
    async () => {
      const response = await listClientSex(filtroConsulta);

      return response;
    }
  );

  const { data: { status, stats } = { status: null, stats: {} } } = useQuery(
    ["analytics component", "listClientStatus", filtroConsulta.changeToRefetch],
    async () => {
      const response = await listClientStatus(filtroConsulta);

      return {
        status: response,
        stats: response,
      };
    }
  );

  const { isLoading: isLoadingThermometer, data: termometro = [] } = useQuery(
    [
      "analytics component",
      "listClientThermometer",
      filtroConsulta.changeToRefetch,
    ],
    async () => {
      const response = await listClientThermometer(filtroConsulta);

      return response;
    }
  );

  const { isLoading: isLoadingAge, data: idade = [] } = useQuery(
    ["analytics component", "listClientAge", filtroConsulta.changeToRefetch],
    async () => {
      const response = await listClientAge(filtroConsulta);

      return response;
    }
  );

  const { isLoading: isLoadingProfession, data: profissoes = [] } = useQuery(
    [
      "analytics component",
      "listClientProfession",
      filtroConsulta.changeToRefetch,
    ],
    async () => {
      const response = await listClientProfession(filtroConsulta);

      return response;
    }
  );

  const {
    isLoading: isLoadingTotalizers,
    data: customerTotalizers = [
      {
        celular: 0,
        email: 0,
        endereco: 0,
        ativos: 0,
      },
    ], // perfilCliente.totalizadores
  } = useQuery(
    ["customerTotalizers", filtroConsulta.changeToRefetch],
    async () => {
      const response = await listCustomerTotalizers(filtroConsulta);
      return response;
    }
  );

  const perfilCliente_INIT = {
    mapa: [],
    pessoa: "",
    show: false,
  };

  const perfilCliente = {
    ...perfilCliente_INIT,
    totalClientes,
    clientes,
    sexo,
    status,
    stats,
    termometro,
    idade,
    profissoes,
    totalizadores: customerTotalizers,
  };

  return (
    <Stack spacing={4}>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Paper
          loading={isLoadingClients}
          icon={<Group color="primary" fontSize="large" />}
          label="Cadastros"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={perfilCliente.clientes?.total}
        />

        <Paper
          loading={isLoadingTotalizers}
          icon={<PhoneIphone color="primary" fontSize="large" />}
          label="Celulares"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={perfilCliente.totalizadores[0]?.celular}
        />

        <Paper
          loading={isLoadingTotalizers}
          icon={<Email color="primary" fontSize="large" />}
          label="Emails"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={perfilCliente.totalizadores[0]?.email}
        />

        <Paper
          loading={isLoadingTotalizers}
          icon={<LocationOn color="primary" fontSize="large" />}
          label="Emails"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={perfilCliente.totalizadores[0]?.endereco}
        />
        <Paper
          loading={isLoadingTotalizers}
          icon={<LocationOn color="primary" fontSize="large" />}
          label="Ativos"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={perfilCliente.totalizadores[0]?.ativos}
        />
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <PaperChart
          loading={isLoadingClients}
          label="Total de clientes"
          className={styles.paperCharts}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(perfilCliente.totalClientes) ? (
            //@ts-ignore
            <Bar
              barLegend
              barDataKey="total_loja"
              xDataKey="nome_loja"
              tooltipFormatter="Qtde. clientes"
              data={perfilCliente.totalClientes}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>

        <PaperChart
          loading={isLoadingGenre}
          label="Gêneros"
          className={styles.paperCharts}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(perfilCliente.sexo) ? (
            //@ts-ignore
            <Bar
              stacked={["Não informado", "Masculino", "Feminino", " "]}
              barLegend
              xDataKey="nome_loja"
              data={perfilCliente.sexo}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <PaperChart
          loading={isLoadingAge}
          label="Idade"
          className={styles.paperCharts}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(perfilCliente.idade) ? (
            //@ts-ignore
            <Bar
              stacked={[
                "0 a 12 anos",
                "13 a 18 anos",
                "19 a 25 anos",
                "26 a 35 anos",
                "36 a 45 anos",
                "46 a 65 anos",
                "acima de 66 anos",
              ]}
              barLegend
              xDataKey="nome_loja"
              data={perfilCliente.idade}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>

        <PaperChart
          loading={isLoadingThermometer}
          label="Termômetro"
          className={styles.paperCharts}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(perfilCliente.termometro) ? (
            //@ts-ignore
            <Bar
              stacked={["Congelado", "Congelando", "Morno", "Quente"]}
              barLegend
              xDataKey="nome_loja"
              data={perfilCliente.termometro}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>
      </Stack>
      <PaperChart
        loading={isLoadingProfession}
        label="Profissões"
        className={styles.paperCreatedDay}
        variant="outlined"
        elevation={0}
      >
        {!isEmpty(perfilCliente.profissoes) ? (
          //@ts-ignore
          <Bar
            barLegend
            barDataKey="qtde"
            xDataKey="descricao"
            tooltipFormatter="Qtde. clientes"
            data={perfilCliente.profissoes}
          />
        ) : (
          <WithoutInformation />
        )}
      </PaperChart>
    </Stack>
  );
}

export default AnalyticsView;
